module.exports = __webpack_public_path__ + "static/img/ok_icon.921b120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/ok_icon.png
// module id = 9CKm
// module chunks = 1